module.exports = __webpack_public_path__ + "img/img_level_15.5cd7f894.png";